import { render } from "./IssueSection.vue?vue&type=template&id=f16a9a58&scoped=true"
import script from "./IssueSection.vue?vue&type=script&lang=js"
export * from "./IssueSection.vue?vue&type=script&lang=js"

import "./IssueSection.vue?vue&type=style&index=0&id=f16a9a58&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/doineedavpn.com/doineedavpn.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f16a9a58"]])

export default __exports__